import backofficeService from "@/api/backoffice";

export default {
  getAll(params) {
    return backofficeService
      .Api()
      .get("lead", { params })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },

  getById(id, params = {}) {
    return backofficeService
      .Api()
      .get(`lead/${id}`, { params })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },

  create(data) {
    return backofficeService
      .Api()
      .post("lead", data)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },

  update(id, data) {
    return backofficeService
      .Api()
      .put(`lead/${id}`, data)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },

  delete(id, params) {
    return backofficeService
      .Api()
      .delete(`lead/${id}`, { params })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
};
